/* -------------------------------------------------------------------------- */
/* ---------------------------------- FRONT --------------------------------- */

// CSS
import "./scss/theme.scss";

// JS
import "./js/theme.js";
if ( document.querySelector('.home') ) {
    import("./js/preloader.js");
}